<div class="text-gray-400 font-italic pt-2 md:pt-0">
  {{ 'LINKED_PLAYER_LEAGUES_MSG' | translate }}
</div>

<p-divider/>

<div>
  <app-loading [active]="isLoading"/>
  @if (customError) {
    <app-info-text [text]="customError" color="text-secondary"/>

    <div class="pt-2">
      <p-button icon="pi pi-id-card" styleClass="p-button-text"
                [label]="'PLAYER_LINKS' | translate" (onClick)="gotoAccountLinks()"/>
    </div>
  } @else {
    <app-message [active]="!!errorMsg" [message]="errorMsg"/>
  }

  @if (teamsLeaguesResponse) {
    @if (teamsLeaguesResponse.teamLeagues?.length > 0) {
      <div>
        {{ 'PLEASE_SELECT_YOUR_TEAM_WITH_LEAGUE' | translate }}
      </div>
      <div class="pt-2">
        <p-select id="client" appendTo="body"
                  [options]="teamsLeaguesResponse.teamLeagues"
                  [(ngModel)]="selectedTeamLeague"
                  [filter]="true"
                  [filterBy]="'participantName,event.name,region.name,season.name'"
                  [placeholder]="'PLEASE_SELECT' | translate"
                  class="grid-comp-full-width">
          <ng-template #item let-option>
            <ng-container [ngTemplateOutlet]="teamLeagueTemplate" [ngTemplateOutletContext]="{data: option}"/>
          </ng-template>
          <ng-template #selectedItem let-option>
            <ng-container [ngTemplateOutlet]="teamLeagueTemplate" [ngTemplateOutletContext]="{data: option}"/>
          </ng-template>
        </p-select>
      </div>

      <p-divider/>

      <div class="pt-1">
        <app-switch [(value)]="calendarSync" label="SYNCHRONIZE_WITH_YOUR_CALENDAR" [disabled]="!isPro"/>
        @if (!isPro) {
          <app-player-profile-pro-feature [onlyLabel]="true"/>
        }
      </div>
    } @else {
      <div>
        {{ 'TABLE_NO_DATA' | translate }}
      </div>
    }

    @if (teamsLeaguesResponse.errorWithDatabase) {
      <app-info-text text="ERROR_WITH_DATABASES_API_CALL" [warningFrontend]="true"/>
    }
  }
</div>

<div class="flex justify-content-end pt-3">
  <app-dialog-button [loading]="isSaving"
                     labelOkButton="ADD_LEAGUE"
                     [okButtonDisabled]="!selectedTeamLeague"
                     (onOkClicked)="onOkClicked()"
                     (onCancelClicked)="onCancelClicked()"/>
</div>

<ng-template #teamLeagueTemplate let-option="data">
  <div>
    <div>
      <div class="flex-1">
        {{option.participantName}}
      </div>
      <div>
        {{option.region?.name}}
      </div>
    </div>
    <div class="text-gray-500 pt-2 flex gap-2">
      <div class="flex-1">
        {{option.event?.name}}
      </div>
      <div>
        {{option.season?.name}}
      </div>
    </div>
  </div>
</ng-template>
